import React from 'react';
import StatsCard from './StatsCard';

interface DashboardStatsProps {
  onSelectTab: (tab: string) => void;
  recentCount: number | string;
  todayCount: number | string;
  newCount: number | string;
  pendingCount: number | string;
}

export const DashboardStats: React.FC<DashboardStatsProps> = ({ 
  onSelectTab, 
  recentCount, 
  todayCount, 
  newCount, 
  pendingCount 
}) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
      
      {/* Προσθήκη cursor-pointer και transition για ωραίο εφέ */}
      
      <div onClick={() => onSelectTab("today")} className="cursor-pointer transition-transform hover:scale-[1.02]">
        <StatsCard title="Ραντεβού Σήμερα" value={todayCount} color="blue" />
      </div>
      
      <div onClick={() => onSelectTab("recent")} className="cursor-pointer transition-transform hover:scale-[1.02]">
        <StatsCard title="Πρόσφατα Ραντεβού" value={recentCount} color="yellow" />
      </div>

      <div onClick={() => onSelectTab("new")} className="cursor-pointer transition-transform hover:scale-[1.02]">
        <StatsCard title="Νέοι Ασθενείς" value={newCount} color="green" />
      </div>

      <div onClick={() => onSelectTab("pending")} className="cursor-pointer transition-transform hover:scale-[1.02]">
        <StatsCard title="Εκκρεμότητες" value={pendingCount} color="red" />
      </div>

    </div>
  );
};